import { createTheme, MantineThemeOverride } from "@mantine/core";
import { mantineThemeSizes, mantineTypography, colors } from "./lib";

export const mantineTheme: MantineThemeOverride = createTheme({
  ...mantineThemeSizes,
  ...mantineTypography,
  colors,
  focusRing: "auto",
  primaryShade: 6,
  primaryColor: "brand-blue",
});
